import React from 'react';
import {Box} from "@mui/material";
import {styled} from "@mui/styles";

const Root = styled(Box)(() => ({
  position: 'absolute',
  right: '0em',
  top: '0em',
  height: '100%',
  width: 'auto',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
}));

type CollapsableCardBodyActionsContainerProps = React.ComponentPropsWithoutRef<'div'>

/**
 * MUI Box component styled in the SecurSpace way. Used in the BodyContainer after the list of items to hold Action Buttons
 * @param children children passed through to the internal Grid component
 * @param rest The rest of the Grid props that will be passed through to the internal Grid component
 * @constructor
 */
const CollapsableCardBodyActionsContainer = ({ children, ...rest}: CollapsableCardBodyActionsContainerProps) => {
  return <Root {...rest}>
    { children }
  </Root>
}

export { CollapsableCardBodyActionsContainer };
